const i = {
  name: "TriangleFill",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 2C11.0318 2 10.1227 2.51195 9.63014 3.34944L1.65282 16.6249L1.64846 16.6323C1.22923 17.3437 1 18.1687 1 19C1 20.6523 2.34772 22 4 22H20C21.6523 22 23 20.6523 23 19C23 18.172 22.7723 17.3414 22.3343 16.6303L14.3701 3.34986C13.8776 2.51213 12.9683 2 12 2Z" fill="currentColor"/>
</svg>
  `
};
export {
  i as TriangleFill
};
